"use client";
import { useGetCustomerStatusQuery } from "@/lib/redux";
import { IMAGES } from "@/lib/constants";
import PanDetails from "./pan-details";
import styles from "./checkeligibility.module.css"
import CheckEligibilityRightCard from "./phone-details";
import CheckEligibilityLeftCard from "./check-eligibility-left";
import { Grid } from "@mui/material";
import { useTranslations } from "next-intl";
import { useRouter } from "@/i18n/routing";
import { usePathname } from "next/navigation";


const CheckEligibilityScreen = ({formik,handleFieldChange}) => {
  const t = useTranslations("Login");
  const router = useRouter();
  const path = usePathname();
    // Example: set background image based on path
  let backgroundImage = "url('/loginbackground.svg')";
  if (path.includes("medical")) {
    backgroundImage = "url('/medical_loan.svg')";
  } else if (path.includes("consumer")) {
    backgroundImage = "url('/consumer_durables.svg')";
  }
  const imgSrc = IMAGES.crifLogo;
  // const {
  //   data: customerStatus,
  //   isLoading: customerStatusLoading,
  //   isError: customerStatusError,
  // } = useGetCustomerStatusQuery();


  // if (customerStatusLoading) {
  //   return <HeroLoaderComponent open={true} loadingLabel={"Please wait for a moment..."} poweredBy={"Powered By"} imgSrc={imgSrc} />; 
  // }
  return (
    <div className={styles["main-body-container"]}>
      <Grid container height={"100%"} sx={{ backgroundColor: "#04251d" }}>
      <Grid
        item
        xs={12}
        sm={12}
        md={6}
        lg={6}
        sx={{
          backgroundImage,
          backgroundRepeat: "no-repeat",
          backgroundColor: "#04251d",
          backgroundSize: "cover",
        }}
        // className={styles["left-card"]}
      >
        <CheckEligibilityLeftCard />
      </Grid>
      <Grid
        bgcolor={"#fff"}
        borderRadius={{
          lg: 0,
          md: 0,
          sm: "20px 20px 0px 0px",
          xs: "20px 20px 0px 0px",
        }}
        item
        xs={12}
        sm={12}
        md={6}
        lg={6}
        // display={"flex"}
        // alignItems={"center"}
        // justifyContent={"center"}
      >
        <PanDetails /> 
      </Grid>
    </Grid>
    </div>
  );
};

export default CheckEligibilityScreen;
